import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import SearchComponent from "./SearchComponent";
import AppLogo from "../assets/images/app-logo.jpg";
import { IconBurger, IconCall, IconClose, IconFacebook } from "../assets/icons";
import { ProductService } from "../services/productService";
// import { toast } from "react-toastify";
import debounce from "lodash.debounce";

const HeaderComponent = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false); // Trạng thái menu mobile

  const [searchResults, setSearchResults] = useState([]);
  const fetchProducts = async (search) => {
    try {
      const response = await ProductService.getListProducts({
        page: 1,
        pageSize: 5,
        search,
      });
      if (!response.Data) {
        // toast.error("Lỗi lấy danh sách sản phẩm!");
        return;
      }
      const { listData } = response.Data;
      setSearchResults(listData);
    } catch (error) {
      // toast.error("Lỗi lấy danh sách sản phẩm!");
    }
  };

  const handleSearch = debounce((value) => {
    fetchProducts(value);
  }, 500);

  const handleResultClick = (result) => {
    // Chuyển trang hoặc thực hiện hành động
    window.location.href = `/products/${result.category}/${result.slug}`;
  };

  return (
    <header className="fixed top-0 left-0 w-full bg-white shadow-md z-50 lg:px-24">
      <div className="flex items-center justify-between py-4 px-4 lg:px-0">
        <div className="flex flex-row gap-2 min-w-[12rem]">
          {/* Logo */}
          <Link to="/">
            <div className="flex gap-2">
              <img src={AppLogo} className="w-12 h-12" alt="Logo" />
              <div className="flex flex-col gap-1">
                <span className="text-primaryColor font-bold">Ly iPhone</span>
                <span className="text-xs font-bold text-gray-500 text-nowrap whitespace-nowrap">
                  253 Hùng Vương, Tam Kỳ
                </span>
              </div>
            </div>
          </Link>
        </div>

        {/* Search Component - Desktop */}
        <div className="lg:flex-grow lg:mx-6 flex items-center max-w-lg gap-1">
          <SearchComponent
            onChange={handleSearch}
            searchResults={searchResults}
            onResultClick={handleResultClick}
            renderResult={(result) => (
              <div className="flex items-center gap-4">
                <img
                  src={result.images[0]?.src || "/placeholder.png"}
                  alt={result.name}
                  className="w-10 h-10 object-cover rounded-md"
                />
                <span>{result.name}</span>
              </div>
            )}
          />
          {/* Icon menu cho mobile */}
          <button
            className="text-2xl text-gray-600 lg:hidden"
            onClick={() => setIsMenuOpen(true)}
          >
            <IconBurger />
          </button>
        </div>

        {/* Navigation Menu - Desktop */}
        <nav className="hidden lg:flex space-x-4 max-w-[30rem] overflow-x-auto">
          <NavLink
            to="/"
            className={({ isActive }) =>
              `text-sm text-nowrap whitespace-nowrap ${
                isActive
                  ? "text-primaryColor font-bold"
                  : "text-gray-500 font-medium"
              }`
            }
          >
            Trang chủ
          </NavLink>
          <NavLink
            to="/about"
            className={({ isActive }) =>
              `text-sm text-nowrap whitespace-nowrap ${
                isActive
                  ? "text-primaryColor font-bold"
                  : "text-gray-500 font-medium"
              }`
            }
          >
            Về chúng tôi
          </NavLink>
          <NavLink
            to="/products"
            className={({ isActive }) =>
              `text-sm text-nowrap whitespace-nowrap ${
                isActive
                  ? "text-primaryColor font-bold"
                  : "text-gray-500 font-medium"
              }`
            }
          >
            Sản phẩm
          </NavLink>
          <NavLink
            to="/services-offers"
            className={({ isActive }) =>
              `text-sm text-nowrap whitespace-nowrap ${
                isActive
                  ? "text-primaryColor font-bold"
                  : "text-gray-500 font-medium"
              }`
            }
          >
            Ưu đãi & Dịch vụ
          </NavLink>
          <NavLink
            to="/contact"
            className={({ isActive }) =>
              `text-sm text-nowrap whitespace-nowrap ${
                isActive
                  ? "text-primaryColor font-bold"
                  : "text-gray-500 font-medium"
              }`
            }
          >
            Liên hệ
          </NavLink>
        </nav>

        {/* Liên hệ */}
        <div className="hidden lg:ml-12 lg:flex gap-2">
          <a
            href="tel:0935255096"
            data-tooltip={"Gọi điện"}
            className="p-2 rounded-md bg-primaryColor hover:scale-110 transition"
          >
            <IconCall className="w-4 h-4 text-blue-500 hover:scale-110 transition fill-white" />
          </a>
          <a
            href="https://facebook.com/lylyiphone"
            target="_blank"
            rel="noopener noreferrer"
            data-tooltip={"Liên hệ qua Facebook"}
            className="p-2 rounded-md bg-primaryColor hover:scale-110 transition"
          >
            <IconFacebook className="w-4 h-4 " />
          </a>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div
          onClick={() => setIsMenuOpen(false)}
          className="fixed inset-0 bg-black bg-opacity-50 z-20"
        >
          <div
            className="fixed top-0 right-0 w-60 bg-white h-full shadow-md z-30 p-6"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-end">
              <button
                className="text-2xl text-gray-600 mb-6"
                onClick={() => setIsMenuOpen(false)}
              >
                <IconClose />
              </button>
            </div>
            <nav className="flex flex-col space-y-8">
              <NavLink
                to="/"
                className={({ isActive }) =>
                  `text-xl font-medium ${
                    isActive
                      ? "text-primaryColor font-bold"
                      : "text-gray-500 font-medium"
                  }`
                }
                onClick={() => setIsMenuOpen(false)}
              >
                Trang chủ
              </NavLink>
              <NavLink
                to="/about"
                className={({ isActive }) =>
                  `text-xl font-medium ${
                    isActive
                      ? "text-primaryColor font-bold"
                      : "text-gray-500 font-medium"
                  }`
                }
                onClick={() => setIsMenuOpen(false)}
              >
                Về chúng tôi
              </NavLink>
              <NavLink
                to="/products"
                className={({ isActive }) =>
                  `text-xl font-medium ${
                    isActive
                      ? "text-primaryColor font-bold"
                      : "text-gray-500 font-medium"
                  }`
                }
                onClick={() => setIsMenuOpen(false)}
              >
                Sản phẩm
              </NavLink>
              <NavLink
                to="/services-offers"
                className={({ isActive }) =>
                  `text-xl font-medium ${
                    isActive
                      ? "text-primaryColor font-bold"
                      : "text-gray-500 font-medium"
                  }`
                }
                onClick={() => setIsMenuOpen(false)}
              >
                Ưu đãi & Dịch vụ
              </NavLink>
              <NavLink
                to="/contact"
                className={({ isActive }) =>
                  `text-xl font-medium ${
                    isActive
                      ? "text-primaryColor font-bold"
                      : "text-gray-500 font-medium"
                  }`
                }
                onClick={() => setIsMenuOpen(false)}
              >
                Liên hệ
              </NavLink>
            </nav>
          </div>
        </div>
      )}
    </header>
  );
};

export default HeaderComponent;
